import { Component } from '@angular/core';

@Component({
  selector: 'lns-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent {}
